import React, { useCallback, useContext } from 'react';
// import { filterTags as initialFilterTags } from '../utils/filter-tags';
import FilterButton from './FilterButton';
import { ConfiguratorContext } from '../../context/ConfiguratorProvider';

const FilterTags = ({
  onClickFilterSingle,
  onClickFilterMultiple,
  isMultipleFilterSelected,
  pathName,
  filterTags,
}) => {
  const { isDev } = useContext(ConfiguratorContext);

  // show specific filters for engagement and elopement locations
  const engagementOrElopementPaths = [
    '/wedding/engagement-locations/',
    '/elopement/nyc-elopement-locations/',
  ];

  const handleClick = useCallback(
    (index, filterIndex, filter, tag, shouldRenderFilter) => {
      if (shouldRenderFilter) {
        onClickFilterMultiple(index, filterIndex, filter, tag);
      } else {
        onClickFilterSingle(index, filterIndex, filter, tag);
      }
    },
    [onClickFilterMultiple, onClickFilterSingle]
  );

  return (
    <>
      {isDev && <pre>FilterTags</pre>}
      {filterTags.map(({ filter, tags, activeFilterIdx }, filterIndex) => {
        // Determine if the current path is one of the engagement or elopement paths
        const isEngagementOrElopementPath =
          engagementOrElopementPaths.includes(pathName);

        // Conditional rendering based on pathName (on engagement locations or elopement locations)
        const shouldRenderFilter =
          (filter === 'indoor-outdoor' && !isEngagementOrElopementPath) ||
          filter === 'other' ||
          (filter === 'budget' && !isEngagementOrElopementPath) ||
          // (filter === 'novo' && !isEngagementOrElopementPath) ||
          filter === 'location' ||
          (filter === 'capacity' && !isEngagementOrElopementPath);

        if (!shouldRenderFilter) {
          return null;
        }
        return (
          <div
            key={filter}
            className={`filter-tag-${filter}`}
            style={{ paddingBottom: filter === 'other' ? '8%' : '' }}
          >
            <p>{filter}</p>
            {tags.map((tag, index) => (
              <FilterButton
                key={tag}
                className="filterTag"
                customClass={
                  isMultipleFilterSelected(index, activeFilterIdx) &&
                  'tagSelected'
                  // filter === 'indoor-outdoor' ||
                  // filter === 'other' ||
                  // filter === 'budget' ||
                  // filter === 'location' ||
                  // filter === 'capacity'
                  //   ? isMultipleFilterSelected(index, activeFilterIdx) &&
                  //     'tagSelected'
                  //   : index === activeFilterIdx && 'tagSelected'
                }
                text={tag}
                name={tag}
                onClick={() => {
                  handleClick(
                    index,
                    filterIndex,
                    filter,
                    tag,
                    shouldRenderFilter
                  );
                }}
              />
            ))}
          </div>
        );
      })}
    </>
  );
};

export default FilterTags;
